import { cn } from "@/lib/utils";
import { type VariantProps, cva } from "class-variance-authority";
import type * as React from "react";

const badgeVariants = cva(
	"inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
	{
		variants: {
			variant: {
				default: "border-primary/20 bg-primary/10 text-primary",
				secondary: "border-border bg-secondary text-secondary-foreground",
				destructive: "border-destructive/20 bg-destructive/10 text-destructive",
				outline: "border-border text-muted-foreground",
				success: "border-success/20 bg-success/10 text-success",
				warning: "border-warning/20 bg-warning/10 text-warning",
				info: "border-info/20 bg-info/10 text-info",
			},
		},
		defaultVariants: {
			variant: "default",
		},
	},
);

export interface BadgeProps
	extends React.HTMLAttributes<HTMLDivElement>,
		VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
	return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
